'use strict';

const headerMenu = {
	init: function () {
		this.openMenu();
		if (window.screen.width < 1250) {
			this.handleclickSubMenu();
			this.handleClickOutside();
		}
		if (window.screen.width >= 1250) {
			this.handleMouseEnterSubMenu();
			this.handleMouseLeaveSubMenu();
		}
	},

	handleMouseEnterSubMenu: function () {
		const parentHadChildren = document.querySelectorAll('.menu-item-has-children')

		parentHadChildren.forEach(item => {
			item.addEventListener('mouseenter', e => {

				if (e.target === item.querySelector('a')) {
					e.preventDefault()
				}

				parentHadChildren.forEach(child => {
					if (child !== item) {
						child.querySelector('.sub-menu').classList.remove('active')
						child.querySelector('a').classList.remove('hovered')
					}
				})

				item.querySelector('.sub-menu').classList.toggle('active')
				item.querySelector('a').classList.toggle('hovered')
			})
		})
	},

	handleMouseLeaveSubMenu: function () {
		const parentHadChildren = document.querySelectorAll('.menu-item-has-children')

		document.addEventListener('mouseover', (e) => {
			const isClickInsideHeader = e.target.closest('li');

			if (!isClickInsideHeader) {
				parentHadChildren.forEach(child => {
					child.querySelector('.sub-menu').classList.remove('active');
					child.querySelector('a').classList.remove('hovered');
				});
			}
		});
	},

	handleclickSubMenu: function () {
		const parentHadChildren = document.querySelectorAll('.menu-item-has-children')

		parentHadChildren.forEach(item => {
			item.addEventListener('click', e => {

				if (e.target === item.querySelector('a')) {
					return;
				}

				parentHadChildren.forEach(child => {
					if (child !== item) {
						child.classList.remove('active')
						child.querySelector('.sub-menu').classList.remove('active')
					}
				})

				item.classList.toggle('active')
				item.querySelector('.sub-menu').classList.toggle('active')
			})
		})
	},

	handleClickOutside: function () {
		const parentHadChildren = document.querySelectorAll('.menu-item-has-children')

		document.addEventListener('click', (e) => {
			const isClickInsideHeader = e.target.closest('header');

			if (!isClickInsideHeader) {
				parentHadChildren.forEach(child => {
					item.querySelector('ul').style.maxHeight = '0 !important';
					child.classList.remove('active');
					child.querySelector('.sub-menu').classList.remove('active');
				});
			}

		});
	},

	openMenu: function () {
		const toggleNav = document.querySelectorAll('.headerNav__mobile__burger');
		const navigation = document.querySelector('.headerNav.navigation');
		toggleNav.forEach(item => {
			item.addEventListener('click', () => {
				navigation.classList.toggle('active');
				document.querySelector('body').classList.toggle('active');
			})
		})
	},
}

export default headerMenu;